// MasterDashboardWalletCard — Feb 2026 (Randy). Achieved-rewards
// ticket-style card. Holographic-foil aesthetic, mature teen/young-adult
// vibe. Uses lucide icons (no emoji). Swipe away = wipe.
import { Sparkle } from "@phosphor-icons/react";
import { Ticket } from "lucide-react";
import { useState } from "react";

export default function MasterDashboardWalletCard({ ticket, onWipe, compact = false }) {
  const [confirming, setConfirming] = useState(false);
  return (
    <div
      className={`relative rounded-2xl overflow-hidden border border-white/15 ${compact ? "p-4" : "p-5"} group`}
      style={{
        // Holographic foil — layered conic + linear gradients + subtle grain.
        background: `
          radial-gradient(120% 100% at 0% 0%, rgba(255,200,240,0.25), transparent 40%),
          radial-gradient(120% 100% at 100% 100%, rgba(140,200,255,0.28), transparent 40%),
          linear-gradient(135deg, #12151A 0%, #1A1E25 50%, #12151A 100%)`,
      }}
      data-testid={`wallet-card-${ticket.id}`}
    >
      {/* perforated stub edge */}
      <div className="absolute top-0 bottom-0 left-16 border-l border-dashed border-white/12" />
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-white/8 border border-white/12 flex items-center justify-center shrink-0">
          <Ticket size={20} className="text-white/80" />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[9px] uppercase tracking-[0.28em] text-white/40 mb-1">Achieved Reward</div>
          <div className={`${compact ? "text-base" : "text-lg"} font-medium text-white leading-tight`} data-testid={`wallet-card-name-${ticket.id}`}>
            {ticket.reward_name}
          </div>
          <div className="text-[10px] uppercase tracking-[0.24em] text-white/50 mt-1.5 flex items-center gap-2">
            <span>{ticket.cost_points} pts</span>
            <span>·</span>
            <span>Earned {new Date(ticket.created_at).toLocaleDateString(undefined, { month: "short", day: "numeric" })}</span>
          </div>
        </div>
      </div>
      <div className="mt-4 flex items-center justify-end gap-2">
        {!confirming ? (
          <button onClick={() => setConfirming(true)} data-testid={`wallet-card-wipe-${ticket.id}`}
            className="text-[10px] uppercase tracking-[0.24em] px-3 py-1.5 rounded-md border border-white/15 text-white/50 hover:text-white hover:border-white/30 opacity-70 group-hover:opacity-100 transition-opacity">
            Use / Wipe
          </button>
        ) : (
          <div className="flex items-center gap-2">
            <button onClick={() => setConfirming(false)} className="text-[10px] uppercase tracking-[0.18em] text-white/40 px-2 py-1">Cancel</button>
            <button onClick={() => onWipe(ticket)} data-testid={`wallet-card-wipe-confirm-${ticket.id}`}
              className="text-[10px] uppercase tracking-[0.18em] px-3 py-1.5 rounded-md bg-white text-black hover:bg-white/90">
              Confirm — used
            </button>
          </div>
        )}
      </div>
      {/* subtle sparkle in the corner */}
      <Sparkle size={12} weight="duotone" className="absolute top-3 right-3 text-white/25" />
    </div>
  );
}
